import { render } from "./Carousel.vue?vue&type=template&id=ccbcabde&scoped=true&ts=true"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"

import "./Carousel.vue?vue&type=style&index=0&id=ccbcabde&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbcabde"]])

export default __exports__